import Vue from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';
import ElementUI from 'element-ui';
import api from '@/api/index.js';
import user from '@/utils/user.js';
import common from '@/utils/common.js';
import config from '@/utils/config.js';
import filtres from '@/utils/filters.js';
import MetaInfo from 'vue-meta-info';
import VueCookies from 'vue-cookies';
import './permission';
import {
    OverlayScrollbarsPlugin
} from 'overlayscrollbars-vue';
import uploader from 'vue-simple-uploader'
import OverlayScrollbars from "overlayscrollbars";
import animated from 'animate.css';
import 'element-ui/lib/theme-chalk/index.css';
import 'overlayscrollbars/css/OverlayScrollbars.css';
import 'normalize.css/normalize.css';
import '@/styles/base.scss';
import '@/assets/fonts/iconfont.css';
import 'swiper/css/swiper.css'




//cnpm install
//yarn install
//cnpm install overlayscrollbars 
//cnpm install overlayscrollbars-vue

Vue.use(ElementUI);
Vue.use(OverlayScrollbarsPlugin);
Vue.use(OverlayScrollbars);
Vue.use(uploader)
/*
this.$cookies.config(expireTimes[,path])  // default: expireTimes = 1d , path=/
this.$cookies.set(keyName, value[, expireTimes[, path[, domain[, secure]]]])   //return this
this.$cookies.get(keyName)       // return value   
this.$cookies.remove(keyName [, path [, domain]])   // return this
this.$cookies.isKey(keyName)        // return false or true
*/
Vue.use(VueCookies);
Vue.use(MetaInfo);
//全局过滤器
Object.keys(filtres).forEach(key => {
    Vue.filter(key, filtres[key])
})

Vue.prototype.$bus = new Vue();//全局
Vue.prototype.$api = api;
Vue.prototype.$config = config;
Vue.prototype.$user = user;
Vue.prototype.$common = common;
Vue.config.productionTip = false;

// if (process.env.NODE_ENV == 'production') {
//      common.prohibitInit();
// }
export default new Vue({
    store,
    router,
    render: h => h(App),
    mounted() {
        document.dispatchEvent(new Event('render-event'))
    },
	beforeCreate:function(){
	  Vue.prototype.$bus=this;
	}
}).$mount('#app')
